export const ourRates = {
  title: ['Our Rates'],
  body: [
    'Sellers receive both the final hammer price PLUS a seller bonus commission. The higher the sale price of your submitted item, the higher the bonus commission.',
    'Refer to the Commission Overview to review the seller bonus structure and potential payout.'
  ],
  textSide: 'right',
  id: 'ourRates',
  backgroundColor: 'gray',
  imageUrlDesktop: jsConfig.links.imagesUrl + 'about-commission-overview-desktop-v2.png',
  imageUrlMobile: jsConfig.links.imagesUrl + 'about-commission-overview-mobile-v2.png',
  hasBorderTop: true,
  overflowImage: false,
  noAssetBackground: true,
  containImage: true,
};

export const singleMarketplaceAboutContent = {
  top: {
    title: ['How It Works.', 'Our Marketplaces.'],
    body: [
      'Fanatics Collect offers a marketplace for every collector and investor type. Since 1998, Fanatics Collects have specialized in Trading Cards, but also support other collectables markets like Comics, Memorabilia, and Video Games. From $50 to $5,000,000, our marketplaces are designed to provide both buyers and sellers the industry’s finest service offering. Liquidity for sellers, and purchasing ease for buyers are top priorities. Simply said, Fanatics Collects produce the finest results, net sellers the highest amounts, and conduct transactions faster than any other established marketplace provider.'
    ],
    textSide: 'right',
    id: 'howItWorks',
    backgroundColor: 'white',
    imageUrlDesktop: jsConfig.links.imagesUrl + 'about-single-top-desktop.png',
    imageUrlMobile: jsConfig.links.imagesUrl + 'about-single-top-mobile.png',
    titleType: 'h1',
    overflowImage: false,
    noAssetBackground: true,
    containImage: true
  },
  main: [
    {
      title: ['Premier Auction'],
      body: [
        'The market\'s most distinguished auction venue, Fanatics Collect designed the Premier Auction from scratch to provide investment caliber assets with the finest possible auction staging. Trading cards are a quickly maturing tangible asset. The Premier Auction provides a venue to support high-end investors seeking to capitalize on it. Every item valued at or above $20,000 receives industry-leading photography, an original written description, video commentary, and marketing outreach. Items valued below this threshold are NOT guaranteed video or written descriptions.',
        'The hammer price includes a 20% buyer\'s premium.'
      ],
      textSide: 'left',
      id: 'premier',
      backgroundColor: 'white',
      darkButtonEmit: 'monthly',
      darkButtonText: 'View Details',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-premier-top-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-premier-top-mobile.png',
      overflowImage: false,
      noAssetBackground: true,
      containImage: true
    },
    {
      title: ['Weekly Sunday Auction'],
      body: [
        'Our flagship auction venue, offering maximum item-diversity and liquidity for collectors and investors to buy and sell 24/7/365. There is always an auction running! Events start every Thursday at 7:00 p.m. PT and close 10 days later, Sunday evening. Extended bidding begins on Sunday at 7:00 p.m. PT. The Weekly Sunday Auction leverages a patent-pending extended bidding period, designed to create a fair, fast-paced, and engaging auction closing experience. Auction items close quickly via closing windows which become increasingly brief as extended bidding progresses. The first closing window ends promptly at 7:30 p.m. PT, so get ready! Most items sell prior to 8:00 p.m. PT.',
        'All sales receive a 20% buyer\'s premium added to the hammer price.'
      ],
      textSide: 'right',
      id: 'weekly',
      backgroundColor: 'gray',
      darkButtonEmit: 'weekly',
      darkButtonText: 'View Details',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-weekly-top-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-weekly-top-mobile.png',
      overflowImage: false,
      noAssetBackground: true,
      containImage: true
    },
    {
      title: ['Buy Now Marketplace'],
      body: [
        'The single largest trading card offering available, these items have asking prices and accept offers from prospective buyers. Sellers can list items from their Vault Portfolio at any time and all sales receive the same seller commission as our other marketplaces. It is free to list and the marketplace is active 24/7/365, so give it a try!',
        'Asking/offer prices already include a 20% buyer\'s premium.'
      ],
      textSide: 'left',
      id: 'fixedPrice',
      backgroundColor: 'gray',
      darkButtonEmit: 'fixed',
      darkButtonText: 'View Details',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'about-fixed-top-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'about-fixed-top-mobile.png',
      hasBorderTop: true,
      overflowImage: false,
      noAssetBackground: true,
      containImage: true,
    },
    {
      title: ['How to Participate'],
      body: [
        '<p class="mb-4">After you register and log into your account, you will gain unlimited access to the Fanatics Collects. The Premier Auction requires additional approval, which you can receive by applying to become a Premier Auction bidder.</p>',
        '<p>Track your bids/offers seamlessly from the Fanatics Collect members portal and trade like a pro! <b>Buyers receives free lifetime Fanatics Vault services on every purchase submitted to their Vault account. Avoid costly shipping fees and sales taxes, too! All items, regardless of category or value, receive free Vault, and zero sales tax when submitted to your Vault account.</b></p>',
        '<hr class="mb-3" />',
        '<p class="mb-4">Selling is straightforward and provides maximum liquidity. Submit your assets to Fanatics Collect and specify your desired marketplace. Don\'t know which venue is best, or unsure about the best time to sell? No problem! Submit your items to your Vault Portfolio and decide later.</p>',
        '<p class="mb-4">The Vault is free for every asset for the first full month after archival, so take your time and pick how and when to sell at your leisure. From your Vault Portfolio, members can submit items to any marketplace with a simple button click. Flash Auction your items into an already active auction event, too, timing the market to your exact preference. Our marketplaces provide sellers with maximum control and flexibility.</p>'
      ],
      textSide: 'right',
      id: 'howTo',
      backgroundColor: 'white',
      imageUrlDesktop: jsConfig.links.imagesUrl + 'how-to-participate-desktop.png',
      imageUrlMobile: jsConfig.links.imagesUrl + 'how-to-participate-mobile.png',
      hasBorderTop: true,
      overflowImage: false,
      noAssetBackground: true,
      containImage: true,
      bodyIsHTML: true
    },
    ourRates
  ]
};

